import { render } from "./MonthYearSelector.vue?vue&type=template&id=19ca98ae&scoped=true&lang=pug"
import script from "./MonthYearSelector.vue?vue&type=script&lang=ts"
export * from "./MonthYearSelector.vue?vue&type=script&lang=ts"

import "./MonthYearSelector.vue?vue&type=style&index=0&id=19ca98ae&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-19ca98ae"

export default script